// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "edfdf25a0bee6f160312e8c16e5466fd602e0375/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};